import type { CityConfig } from "../city-template/types";

export const westValleyCityUTConfig: CityConfig = {
  city: "West Valley City",
  state: "Utah",
  stateAbbr: "UT",
  slug: "west-valley-city",
  route: "/cities/west-valley-city",
  title: "Emergency Passport West Valley City, UT | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in West Valley City, UT — as fast as 24 hours. Serving Salt Lake County's largest suburb. A+ BBB rated registered State Dept. courier serving the Maverik Center and Salt Lake Valley communities. No office visit required.",
  h1: "Emergency & Expedited Passport Services in West Valley City, UT",
  heroSubtitle: "Concert trip to Japan leaving in 10 days at USANA Amphitheatre season? Family wedding in Mexico City and your passport expired three months ago? Business conference in Frankfurt and you forgot to renew? We help West Valley City residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20West%20Valley%20City%20Utah%20Salt%20Lake%20County%20suburban%20landscape%20with%20Maverik%20Center%20arena%20Wasatch%20Mountains%20in%20background%20Oquirrh%20Mountains%20to%20the%20west%20urban%20residential%20neighborhoods%20green%20parks%20wide%20boulevards%20golden%20hour%20warm%20summer%20light%20professional%20photography&width=1800&height=700&seq=west-valley-city-ut-hero-2026&orientation=landscape",
  heroImageAlt: "West Valley City Utah with Maverik Center and Wasatch Mountains at golden hour",
  geoPosition: "40.6916;-112.0010",
  geoPlacename: "West Valley City, Utah",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
    distance: "Located in Aurora, CO — approximately 530 miles east of West Valley City via I-80",
  },
  nearbyCitiesZips: [
    { name: "West Valley City", zips: "84119, 84120, 84128" },
    { name: "Salt Lake City", zips: "84101, 84102, 84103, 84104, 84105, 84106" },
    { name: "Taylorsville", zips: "84118, 84123, 84129" },
    { name: "Kearns", zips: "84118" },
    { name: "Magna", zips: "84044" },
    { name: "West Jordan", zips: "84081, 84084, 84088" },
    { name: "South Jordan", zips: "84009, 84095" },
    { name: "Murray", zips: "84107, 84121, 84123" },
    { name: "Midvale", zips: "84047" },
    { name: "Sandy", zips: "84070, 84090, 84091, 84092, 84093, 84094" },
    { name: "Draper", zips: "84020" },
    { name: "Riverton", zips: "84065, 84096" },
    { name: "Herriman", zips: "84096" },
    { name: "South Salt Lake", zips: "84115, 84119" },
    { name: "Millcreek", zips: "84106, 84107, 84109, 84117, 84124" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Salt Lake Valley departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Salt Lake Valley Hub", desc: "Serving West Valley City, Taylorsville, Kearns, Magna, and Salt Lake County" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Salt Lake City, UT", route: "/cities/salt-lake-city" },
    { name: "Fast passport renewal in Sandy, UT", route: "/cities/sandy-ut" },
    { name: "Emergency passport help in Provo, UT", route: "/cities/provo" },
    { name: "Urgent passport services in Ogden, UT", route: "/cities/ogden" },
    { name: "Same-day passport help in Denver, CO", route: "/denver" },
    { name: "Passport courier services in St. George, UT", route: "/cities/st-george" },
  ],
  fpcOfficeNote: "Fast Passport Center serves West Valley City remotely via secure courier. We do not have a walk-in office in West Valley City — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Salt Lake County and the Wasatch Front.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Salt Lake County and the central Wasatch Front including Davis, Utah, and Tooele counties",
  serviceAreaIntro: "From the bustling Maverik Center and Valley Fair Mall area of West Valley City to the suburban neighborhoods of Taylorsville and Kearns, from the historic mining town of Magna on the edge of the Great Salt Lake to the rapidly growing communities of West Jordan and South Jordan, from the corporate corridors of Murray and Midvale to the Wasatch foothills of Sandy and Draper — Fast Passport Center serves the entire Salt Lake Valley. We regularly help travelers from Salt Lake County, Utah County, and surrounding areas get their passports fast without the 530-mile drive to Denver.",
  nearbyCitiesIntro: "We serve all West Valley City neighborhoods and the surrounding Salt Lake Valley area including Taylorsville, Kearns, Magna, West Jordan, South Jordan, Murray, Midvale, Sandy, Draper, Riverton, and Herriman. If you are anywhere in Salt Lake County, we have you covered.",
  howItWorksIntro: "Most West Valley City travelers complete everything online and ship documents overnight. No need to drive to Denver or even downtown Salt Lake — we handle the courier submission for you.",
  mistakesIntro: "West Valley City travelers often face a 7.5-hour drive to the nearest regional passport agency in Denver. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "West Valley City and Salt Lake County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in West Valley City? Here are the most common ones we hear from Salt Lake Valley travelers.",
  statePageRoute: "/states/utah",
  statePageName: "Utah",
  dmvWebsite: "https://dmv.utah.gov",
  dmvLabel: "Utah DMV — Division of Motor Vehicles",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For West Valley City travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Maria G.",
      location: "West Valley City, UT",
      rating: 5,
      text: "My sister's wedding in Guadalajara was in 6 days and I realized my passport was expired. Fast Passport Center got my renewal in 30 hours. Never left the Salt Lake Valley. From West Valley to Jalisco in a week!",
      service: "Passport Renewal",
    },
    {
      name: "Tony R.",
      location: "Kearns, UT",
      rating: 5,
      text: "Family medical emergency in Manila. Fast Passport Center processed my emergency passport in 24 hours flat. My dedicated agent was incredible — called me with updates every step. Truly lifesaving.",
      service: "Emergency Passport",
    },
    {
      name: "Jennifer P.",
      location: "Taylorsville, UT",
      rating: 5,
      text: "My twins needed first passports for our London trip. Fast Passport Center handled the whole child passport process. Both came in 3 days. Salt Lake Valley parents — these folks are the real deal.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "west-valley-city-ut-1",
      name: "West Valley City Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3490 S 4400 W",
      city: "West Valley City",
      state: "UT",
      zip: "84120",
      phone: "(801) 964-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central West Valley City",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary West Valley City facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "west-valley-city-ut-2",
      name: "Salt Lake County Clerk — Passport Acceptance",
      type: "County Clerk Passport Acceptance",
      address: "2001 S State St, Room S2-200",
      city: "Salt Lake City",
      state: "UT",
      zip: "84190",
      phone: "(385) 468-7400",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "10 miles northeast — Salt Lake County Government Center",
      website: "https://slco.org/clerk/passports/",
      websiteLabel: "Salt Lake County Clerk Passports",
      notes: "Major Salt Lake County passport acceptance center. Appointments recommended. Serves entire county including West Valley City.",
      icon: "ri-government-line",
    },
    {
      id: "west-valley-city-ut-3",
      name: "Taylorsville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4987 S Redwood Rd",
      city: "Taylorsville",
      state: "UT",
      zip: "84123",
      phone: "(801) 262-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "3 miles east of West Valley City",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for eastern West Valley City and Taylorsville residents. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "west-valley-city-ut-4",
      name: "Murray Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4989 S State St",
      city: "Murray",
      state: "UT",
      zip: "84107",
      phone: "(801) 262-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "6 miles east of West Valley City",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Murray and southern Salt Lake Valley. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "west-valley-city-ut-5",
      name: "Magna Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "8470 W 2700 S",
      city: "Magna",
      state: "UT",
      zip: "84044",
      phone: "(801) 250-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "6 miles west of West Valley City",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Magna and western Salt Lake County. Call ahead for passport appointment availability.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 7.5 hour drive to Denver", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "West Valley City photo shops sometimes use retail backgrounds. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Salt Lake County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many West Valley City applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Denver regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Salt Lake Valley families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "West Valley City travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in West Valley City." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your West Valley City address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in West Valley City before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in West Valley City for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 7.5-hour drive to Denver." },
    { q: "How fast can I renew my passport in West Valley City?", a: "Fast Passport Center offers fast passport renewal in West Valley City in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to West Valley City?", a: "The nearest regional passport agency to West Valley City is the Denver Passport Agency, approximately 530 miles east via I-80. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from West Valley City without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near West Valley City?", a: "Same-day passport appointments are only available at the Denver Regional Passport Agency — approximately 7.5 hours from West Valley City — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Salt Lake County residents." },
    { q: "Do you serve the entire Salt Lake Valley?", a: "Absolutely. Fast Passport Center serves the entire Salt Lake Valley including West Valley City, Taylorsville, Kearns, Magna, West Jordan, South Jordan, Murray, Midvale, Sandy, and all surrounding communities. Our courier service works seamlessly from any address in Salt Lake County." },
    { q: "Can I expedite a child passport in West Valley City?", a: "Yes. Fast Passport Center expedites child passports in West Valley City for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Salt Lake Valley families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in West Valley City with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Denver Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — West Valley City", address: "5675 W 6200 S, West Valley City, UT 84118", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — West Valley City", address: "3380 S 5600 W, West Valley City, UT 84120", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Taylorsville", address: "5666 S Redwood Rd, Taylorsville, UT 84123", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walmart Supercenter — Kearns", address: "5675 W 6200 S, Kearns, UT 84118", hours: "Mon–Sun: 6AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "Utah DMV — West Valley City",
      address: "2780 W 4700 S, West Valley City, UT 84129",
      hours: "Mon–Fri: 7AM–5PM",
      note: "Driver license and REAL ID services. Appointment recommended. Convenient central Salt Lake Valley location.",
      featured: true,
    },
    {
      name: "Utah DMV — Draper",
      address: "14555 S Minute Man Dr, Draper, UT 84020",
      hours: "Mon–Fri: 7AM–5PM",
      note: "Serves southern Salt Lake County. REAL ID available.",
      featured: false,
    },
    {
      name: "Utah DMV — Fairpark (Salt Lake City)",
      address: "1095 Motor Ave, Salt Lake City, UT 84116",
      hours: "Mon–Fri: 7AM–5PM",
      note: "Downtown Salt Lake location. REAL ID available. Appointment recommended.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "SLC",
      name: "Salt Lake City International Airport",
      distance: "10 miles northeast of West Valley City",
      address: "776 N Terminal Dr, Salt Lake City, UT 84122",
      note: "Major international airport with direct flights worldwide. About 15–20 minutes from West Valley City via I-215.",
      flightUrl: "https://www.slcairport.com/",
      flightLabel: "SLC Airport",
      featured: true,
    },
    {
      code: "PVU",
      name: "Provo Airport",
      distance: "45 miles south of West Valley City",
      address: "3421 W Mike Jense Pkwy, Provo, UT 84601",
      note: "Regional airport with Allegiant Air and Breeze Airways service. About 50 minutes via I-15.",
      flightUrl: "https://www.provo.org/community/airport",
      flightLabel: "PVU Airport",
      featured: false,
    },
  ],
};